import { useIntl } from "react-intl";

export function useWorkspaceSignalArchiveDescription() {
  const intl = useIntl();
  return intl.formatMessage({
    defaultMessage: `Archiving moves this signal to the archives and removes it from all receiver units.`,
    description: "WorkspaceSignalDetail Archive Description",
  });
}
